import withRematch from 'with-rematch';

import HelloJsAuthButton from './HelloJsAuthButton';
import enhancer from './HelloJsAuthButton.enhancer';

export default withRematch(enhancer)(HelloJsAuthButton);
